<template>
  <b-container
    ref="navmain"
    fluid
    class="app-nav shadow_1 h-100 px-0 text-font-grey bg-white"
  >
    <transition-group name="slideside" mode="out-in">
      <b-row align-v="center" class="px-0" key="logo-row">
        <b-col
          v-if="$root.isCollapsed"
          class="text-right"
          cols="3"
          lg="2"
          key="padspace"
        >
        </b-col>
        <b-col class="px-1 py-2 mt-2" cols="6" md="12">
          <router-link :to="{ name: 'CompanyHome' }" class="">
            <img
              v-if="menuIsCompact && !$root.isCollapsed"
              :src="require(`@/assets/${$root.scope}/dot-logo.svg`)"
              :alt="$t('NavigationOperatore.logo_alt')"
              class="app-nav__logo app-nav__logo--compact px-lg-2 app_logo_compact"
              key="icon_logo"
            />
            <img
              v-else
              :src="require(`@/assets/${$root.scope}/logo.svg`)"
              :alt="$t('NavigationOperatore.logo_alt')"
              class="app-nav__logo app_logo_full"
              key="full_logo"
            />
          </router-link>
        </b-col>
        <b-col
          key="mobile_ham"
          v-if="$root.isCollapsed"
          class="text-right"
          cols="3"
          lg="2"
          @click="menuVisible = !menuVisible"
          @keydown.enter.prevent="menuVisible = !menuVisible"
          @keydown.space.prevent="menuVisible = !menuVisible"
          role="button"
          tabindex="0"
          :aria-label="$t('NavigationOperatore.toggle_menu')"
          :aria-expanded="menuVisible.toString()"
        >
          <b-icon font-scale="1.5" icon="filter-left" aria-hidden="true"></b-icon>
        </b-col>
      </b-row>
      <b-row cols="1" class="px-0" key="menu-row" v-if="menuVisible">
        <b-col
          class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left app-nav__toggle"
          v-if="!$root.isCollapsed"
          key="desk_ham"
        >
          <p class="pb_15 nav__item bg-white">
            <span
              class="d-flex align-items-center pl-1 py-1 general_border_3 point pt-3"
              @click="handleMenuSize"
              @keydown.enter.prevent="handleMenuSize"
              @keydown.space.prevent="handleMenuSize"
              role="button"
              tabindex="0"
              :aria-label="$t('NavigationOperatore.toggle_menu')"
            >
              <b-icon font-scale="1.7" icon="filter-left" aria-hidden="true"></b-icon>
              <span class="mb-0 ml-2"></span>
              <span v-if="!menuIsCompact" class="text-font-light-grey"
                >MENU</span
              >
            </span>
          </p>
        </b-col>
        <b-col class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left">
          <p class="text-font-light-grey">
            <span :class="menuIsCompact ? 'text-white' : ''"></span>
          </p>
          <p class="pb_15 nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3 croom"
              :class="
                this.$route.name === 'CompanyHome'
                  ? 'router-link-exact-active'
                  : ''
              "
              :to="{ name: 'CompanyHome' }"
            >
              <b-icon font-scale="1.3" icon="house-door"></b-icon>
              <span class="mb-0 ml-2">Monitoraggio</span>
            </router-link>
          </p>
          <p
            class="pb_15 nav__item bg-white"
            v-if="activeRefs.includes(1) || activeRefs.includes(2)"
          >
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3 croom"
              :to="{ name: agendaSet.routeName }"
            >
              <b-icon font-scale="1.3" :icon="agendaSet.logo"></b-icon>
              <span class="mb-0 ml-2">{{ agendaSet.name }}</span>
            </router-link>
          </p>
          <p v-if="isFirstLevel" class="pb_15 nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3 croom"
              :to="{ name: analiticheSet.routeName }"
            >
              <b-icon font-scale="1.3" :icon="analiticheSet.logo"></b-icon>
              <span class="mb-0 ml-2">{{ analiticheSet.name }}</span>
            </router-link>
          </p>
          <p class="pb_15 nav__notifications">
            <NotificationCenter />
            <!-- <span class="mb-0 ml-2">Notifiche</span> -->
          </p>
        </b-col>
        <b-col class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left">
          <!-- <p class="text-font-light-grey">
            <span :class="menuIsCompact ? 'text-white' : ''">SERVIZI</span>
          </p> -->
          <template v-for="(service, ind) in activeServices">
            <p
              v-if="activeRefs.includes(service.position_ref)"
              class="pb_15 nav__item"
              :class="service.submenu ? 'bg-mdm-light-grey' : 'bg-white'"
              :key="ind"
            >
              <template v-if="service.submenu">
                <span
                  :key="'sub-m-' + service.routeName"
                  class="d-flex align-items-center pl-1 py-1 general_border_3 point"
                  :class="
                    $route.name === service.routeName
                      ? 'router-link-exact-active'
                      : ''
                  "
                  @click="service.submenuVisible = !service.submenuVisible"
                  @keydown.enter.prevent="service.submenuVisible = !service.submenuVisible"
                  @keydown.space.prevent="service.submenuVisible = !service.submenuVisible"
                  role="button"
                  tabindex="0"
                  :aria-expanded="service.submenuVisible ? 'true' : 'false'"
                  :aria-controls="service.name + '-sub'"
                >
                  <b-icon font-scale="1.3" :icon="service.logo" aria-hidden="true"></b-icon>
                  <span class="mb-0 ml-2 text-capitalize">{{
                    service.name
                  }}</span>
                  <b-icon
                    font-scale="1"
                    :icon="
                      service.submenuVisible ? 'chevron-up' : 'chevron-down'
                    "
                    class="mr-1 ml-auto"
                    aria-hidden="true"
                  ></b-icon>
                </span>
                <b-collapse
                  class="mt-1"
                  :id="service.name + '-sub'"
                  v-model="service.submenuVisible"
                >
                  <template v-for="rt in service.subroutes">
                    <p
                      v-if="
                        !rt.position_ref ||
                        (rt.position_ref &&
                          activeRefs.includes(rt.position_ref))
                      "
                      :key="'sub-' + rt.name"
                      class="mb-1"
                    >
                      <router-link
                        class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-center"
                        :to="{
                          name: service.routeName,
                          params: { section: rt.path },
                        }"
                        exact-active-class="nav-active"
                      >
                        <b-iconstack aria-hidden="true" font-scale="1.3">
                          <b-icon
                            stacked
                            icon="circle"
                            variant="font-grey"
                            scale="0.55"
                          ></b-icon>
                          <b-icon
                            stacked
                            icon="circle"
                            variant="extra-light"
                          ></b-icon>
                        </b-iconstack>
                        <span class="mb-0 ml-2 text-capitalize">{{
                          rt.name
                        }}</span>
                      </router-link>
                    </p>
                  </template>
                </b-collapse>
              </template>
              <template v-else>
                <router-link
                  class="d-flex align-items-center pl-1 py-1 general_border_3 croom"
                  :to="{
                    name: service.routeName,
                  }"
                >
                  <b-icon font-scale="1.3" :icon="service.logo"></b-icon>
                  <span class="mb-0 ml-2 text-capitalize">{{
                    service.name
                  }}</span>
                </router-link>
              </template>
            </p>
          </template>
          <p class="nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-center"
              :to="{ name: centriErogatori.routeName }"
              :class="
                $route.name === centriErogatori.routeName
                  ? 'router-link-exact-active'
                  : ''
              "
            >
              <b-icon font-scale="1.3" :icon="centriErogatori.logo"></b-icon>
              <span class="mb-0 ml-2 text-capitalize">{{
                centriErogatori.name
              }}</span>
            </router-link>
          </p>
          <p class="nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-center"
              :to="{
                name: ricercaPrestazioni.routeName,
                params: { section: 'prestazioni' },
              }"
              :class="
                $route.name === ricercaPrestazioni.routeName
                  ? 'router-link-exact-active'
                  : ''
              "
            >
              <b-icon font-scale="1.3" :icon="ricercaPrestazioni.logo"></b-icon>
              <span class="mb-0 ml-2 text-capitalize"
                >{{ ricercaPrestazioni.name }}
              </span>
            </router-link>
          </p>
          <p class="nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3 croom"
              :to="{ name: 'gestione checklist templates' }"
              :class="
                $route.name === 'gestione checklist templates'
                  ? 'router-link-exact-active'
                  : ''
              "
            >
              <b-icon font-scale="1.3" icon="check2-square"></b-icon>
              <span class="mb-0 ml-2 text-capitalize">{{
                $t('NavigationOperatoreCRoom.checklist_templates')
              }}</span>
            </router-link>
          </p></b-col
        >

        <b-col class="px-2 px-md-4 px-lg-4 pb-xl-2 pb-1 pt-0 text-left">
          <p class="text-font-light-grey">
            <span :class="menuIsCompact ? 'text-white' : ''"></span>
          </p>
          <p class="pb_15 nav__item bg-white app-nav__user">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3 croom"
              :to="{ name: 'profilo operatore' }"
            >
              <b-avatar
                v-if="user && user.profile_pic"
                variant="white"
                :src="user.profile_pic"
                size="sm"
                rounded
              >
              </b-avatar>
              <b-icon
                v-else
                font-scale="1.3"
                :icon="
                  this.$route.name === 'profilo operatore'
                    ? 'person-fill'
                    : 'person'
                "
              ></b-icon>
              <span class="mb-0 ml-2 text-capitalize">{{ welcomeName }}</span>
            </router-link>
          </p>
          <p
            class="pb_15 bg-mdm-light-grey nav__item"
            v-if="canSeeImpostazioni"
            :aria-controls="impostazioniSet.name + '-sub'"
          >
            <span
              class="d-flex align-items-center pl-1 py-1 general_border_3 point"
              :class="
                $route.name === 'impostazioniOperatore'
                  ? 'router-link-exact-active'
                  : ''
              "
              @click="
                impostazioniSet.submenuVisible = !impostazioniSet.submenuVisible
              "
              @keydown.enter.prevent="impostazioniSet.submenuVisible = !impostazioniSet.submenuVisible"
              @keydown.space.prevent="impostazioniSet.submenuVisible = !impostazioniSet.submenuVisible"
              role="button"
              tabindex="0"
              :aria-expanded="impostazioniSet.submenuVisible ? 'true' : 'false'"
              :aria-controls="impostazioniSet.name + '-sub'"
            >
              <b-icon font-scale="1.3" :icon="impostazioniSet.logo" aria-hidden="true"></b-icon>
              <span class="mb-0 ml-2">{{ impostazioniSet.name }}</span>
              <b-icon
                font-scale="1"
                :icon="
                  impostazioniSet.submenuVisible ? 'chevron-up' : 'chevron-down'
                "
                class="mr-1 ml-auto"
                aria-hidden="true"
              ></b-icon>
            </span>
            <template v-if="impostazioniSet.submenu">
              <b-collapse
                class="mt-1"
                :id="impostazioniSet.name + '-sub'"
                v-model="impostazioniSet.submenuVisible"
              >
                <p
                  v-for="rt in filteredImpostazioniSubroutes"
                  :key="'sub-' + rt.name"
                  class="mb-1"
                >
                  <router-link
                    class="d-flex align-items-center pl-1 py-1 general_border_3 align-items-center"
                    :to="{
                      name: impostazioniSet.routeName,
                      params: { section: rt.path },
                    }"
                    exact-active-class="nav-active"
                  >
                    <b-iconstack aria-hidden="true" font-scale="1.3">
                      <b-icon
                        stacked
                        icon="circle"
                        variant="font-grey"
                        scale="0.55"
                      ></b-icon>
                      <b-icon
                        stacked
                        icon="circle"
                        variant="extra-light"
                      ></b-icon>
                    </b-iconstack>
                    <span class="mb-0 ml-2 text-capitalize">{{ rt.name }}</span>
                  </router-link>
                </p>
              </b-collapse>
            </template>
          </p>
          <p class="pb_15 nav__item bg-white">
            <router-link
              class="d-flex align-items-center pl-1 py-1 general_border_3 croom"
              :to="{ name: 'guida' }"
            >
              <b-icon
                font-scale="1.3"
                :icon="
                  this.$route.name === 'guida'
                    ? 'info-circle-fill'
                    : 'info-circle'
                "
              ></b-icon>
              <span class="mb-0 ml-2">Guida</span>
            </router-link>
          </p>
          <p class="pb_15 nav__item bg-white general_border_3">
            <button
              type="button"
              class="nav__accessibility-trigger d-flex align-items-center pl-1 py-1"
              @click="handleAccessibilityShortcut"
              @keydown.enter.prevent="handleAccessibilityShortcut"
              @keydown.space.prevent="handleAccessibilityShortcut"
              aria-controls="accessibility-toolbar"
              :aria-label="$t('NavigationOperatore.accessibility')"
            >
              <b-icon font-scale="1.3" icon="sliders" aria-hidden="true"></b-icon>
              <span class="mb-0 ml-2">
                {{ $t('NavigationOperatore.accessibility') }}
              </span>
            </button>
          </p>
          <SendHelpRequest />
        </b-col>
        <!-- L'uscita è passata al menu dell'utente nell'header (2026-09-08):
             la modale `logout-confirm` resta qui perché è da qui che si apre. -->
      </b-row>
    </transition-group>
    <b-modal
      id="logout-confirm"
      centered
      :title="$t('NavigationOperatore.logout_confirm_title')"
      :ok-title="$t('NavigationOperatore.logout_confirm_ok')"
      ok-variant="popup-button"
      :cancel-title="$t('annulla')"
      cancel-variant="popup-button mr-2"
      footer-border-variant="white"
      @ok="onSubmit"
      @cancel="$bvModal.hide('logout-confirm')"
    >
    </b-modal>
  </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NotificationCenter from "@/app/layout/components/NotificationCenter.vue";
import SendHelpRequest from "@/app/common/components/utilities/SendHelpRequest.vue";
import { requestAccessibilityToolbarFocus } from "@/_utils/accessibility";

export default {
  name: "NavigationOperatoreCRoom",
  props: ["wlistener"],
  components: {
    NotificationCenter,
    SendHelpRequest,
  },
  watch: {
    $route(to, from) {
      if (this.$root.isCollapsed) {
        this.menuVisible = false;
      }
    },
    wlistener: function () {
      this.menuIsCompact = this.$refs.navmain.clientWidth <= 80;
    },
    company: function (comp) {
      if (comp) {
        this.isFirstLevel = comp.level === 1;
      }
    },
  },
  computed: {
    welcomeName() {
      if (this.user && this.user.anagrafica && this.user.anagrafica.name && this.user.anagrafica.surname) {
        return (
          this.user.anagrafica.name.toUpperCase() +
          " " +
          this.user.anagrafica.surname.toUpperCase().slice(0, 1) +
          "."
        );
      }
      return "Profilo";
    },
    canSeeImpostazioni() {
      if (this.user && this.user.type === 1) {
        if (
          !this.user.permessi.includes("gestire attività e questionari") &&
          !this.user.permessi.includes("somministrare questionari")
        ) {
          const activeServices = this.activeServices.filter(
            (service) => service.position_ref !== 3
          );
          this.activeServices = activeServices;
        }
        return (
          this.user.permessi.includes("visualizzare anagrafica azienda") ||
          this.user.permessi.includes("gestire impostazioni dei servizi") ||
          this.user.permessi.includes("gestire operatori")
        );
      }
      return true;
    },
    // Filtro senza riscrivere impostazioniSet.subroutes: i servizi attivi
    // (activeRefs) arrivano dopo il primo disegno del menu, e una voce tolta
    // finché erano vuoti non tornava più (come filteredImpostazioniSubroutes
    // di NavigationOperatore)
    filteredImpostazioniSubroutes() {
      let routes = this.impostazioniSet.subroutes;
      if (this.user && this.user.type === 1 && this.user.permessi) {
        if (!this.user.permessi.includes("gestire operatori")) {
          routes = routes.filter((route) => route.path !== "operatori");
        }
        if (!this.user.permessi.includes("visualizzare anagrafica azienda")) {
          routes = routes.filter(
            (route) =>
              route.path !== "anagrafica" &&
              route.path !== "sottoscrizioni" &&
              route.path !== "personalizzazione"
          );
        }
        routes = routes.filter(
          (route) =>
            !route.position_ref ||
            (this.activeRefs.includes(route.position_ref) &&
              this.companyHasService(route.position_ref))
        );
      }
      return routes;
    },
    ...mapState("utente", ["status", "user"]),
    ...mapState("company", ["companyLoggedIn", "company"]),
    ...mapState("settings", ["activeRefs", "userSubscriptionNeeds"]),
  },
  data() {
    return {
      menuVisible: true,
      showCompanyAlert: null,
      isFirstLevel: true,
      positions: {
        1: "prenotazioni",
        2: "teleconsulto",
        3: "attivita",
        4: "pazienti",
        5: "agenda",
        6: "clienti",
      },
      activeServices: [
        {
          name: "Pazienti",
          logo: "journal-medical",
          disabled: false,
          position_ref: 4,
          routeName: "pazienti",
          scope: undefined,
          submenu: false,
        },
        {
          name: "Prenotazioni",
          logo: "calendar2",
          disabled: false,
          position_ref: 1,
          routeName: "prenotazioni",
          scope: undefined,
          submenu: true,
          submenuVisible: false,
          subroutes: [
            {
              name: "Gestione",
              path: "prenotazioni",
            },
            {
              name: "Strumenti",
              path: "strumenti",
            },
            {
              name: "Report",
              path: "report",
            },
            {
              name: "Recall",
              path: "recall",
            },
          ],
        },
        {
          name: "Teleconsulto",
          logo: "chat-left",
          disabled: false,
          position_ref: 2,
          routeName: "teleconsulto",
          scope: undefined,
          submenu: true,
          submenuVisible: false,
          subroutes: [
            {
              name: "Rapido",
              path: "rapido",
              position_ref: 10,
            },
            {
              name: "Pediatrico",
              path: "pediatrico",
              position_ref: 11,
            },
            {
              name: "Specialistico",
              path: "specialistico",
              position_ref: 2,
            },
            // {
            //   name: "Richieste",
            //   path: "prenotazioni"
            // },
            // {
            //   name: "Oggi",
            //   path: "videocall"
            // }
          ],
        },
        {
          name: "Screening",
          logo: "check2-square",
          disabled: false,
          position_ref: 3,
          routeName: "attivita",
          scope: undefined,
          submenu: true,
          submenuVisible: false,
          subroutes: [
            {
              name: "Raccolte",
              path: "raccolte",
            },
            {
              name: "Questionari",
              path: "questionari",
            },
            {
              name: "Sessioni",
              path: "sessioni",
            },
          ],
        },
        // {
        //   name: "Emergenze",
        //   logo: "exclamation-triangle",
        //   disabled: false,
        //   position_ref: 10,
        //   routeName: "emergenze",
        //   scope: undefined,
        //   submenu: false
        // }
      ],
      agendaSet: {
        name: "Calendario",
        position_ref: 5,
        routeName: "agenda appuntamenti",
        logo: "calendar4",
        disabled: false,
        btnText: "Consulta",
      },
      centriErogatori: {
        name: "Centri erogatori",
        position_ref: 0,
        routeName: "centri erogatori",
        logo: "geo-alt",
        disabled: false,
        btnText: "Consulta",
      },
      ricercaPrestazioni: {
        name: "Ricerca prestazioni",
        position_ref: 0,
        routeName: "ricerca prestazioni",
        logo: "search",
        disabled: false,
        btnText: "Consulta",
      },
      analiticheSet: {
        name: "Statistiche",
        routeName: "analitiche",
        logo: "graph-up",
        disabled: false,
      },
      impostazioniSet: {
        name: "Impostazioni",
        routeName: "impostazioniOperatore",
        logo: "gear",
        disabled: false,
        submenu: true,
        submenuVisible: false,
        subroutes: [
          {
            name: "Servizi",
            path: "servizi",
          },
          {
            name: "Operatori",
            path: "operatori",
          },
          {
            name: "Anagrafica",
            path: "anagrafica",
          },
          {
            name: "Sezioni Scheda",
            path: "feature",
          },
          {
            name: "Personalizzazione",
            path: "personalizzazione",
            position_ref: 16,
          },
        ],
      },
      appuntamentiSet: {
        name: "Appuntamenti",
        logo: "kanban",
        disabled: false,
        position_ref: 5,
        routeName: "appuntamentiASL",
        submenu: true,
        submenuVisible: false,
        subroutes: [
          {
            name: "Storico",
            path: "lista",
          },
          {
            name: "Nuovo",
            path: "nuovo",
          },
        ],
      },
      menuIsCompact: false,
    };
  },
  methods: {
    ...mapActions("utente", ["logout"]),
    ...mapActions("company", ["logUserCompanyIn", "companyLogin"]),
    companyHasService(ref) {
      if (this.company && this.company.active_services) {
        return this.company.active_services.find(
          (el) => el.position_ref === ref
        )
          ? true
          : false;
      }
      return false;
    },
    onSubmit() {
      this.logout();
    },
    handleAccessibilityShortcut() {
      requestAccessibilityToolbarFocus();
    },
    checkPath() {
      if (this.user) {
        return "/" + this.user.i_am + "/home";
      }
    },
    handleMenuSize() {
      var navById = document.getElementsByClassName("nav-desktop")[0];
      var currentWid = navById.clientWidth;
      if (currentWid <= 80) {
        //
        navById.style.minWidth = "inherit";
        navById.style.flex = "0 0 15em";
        this.menuIsCompact = false;
      } else {
        //
        navById.style.minWidth = "0";
        navById.style.flex = "0 0 79px";
        this.menuIsCompact = true;
      }
    },
  },
  created() {
    if (this.$root.isCollapsed) {
      this.menuVisible = false;
    }
  },
  mounted() {
    // console.log(this.$refs.navmain.clientWidth);
    this.menuIsCompact = this.$refs.navmain.clientWidth <= 80;
  },
};
</script>

<style lang="scss" scoped>
.nav__accessibility-trigger {
  background: transparent;
  border: 0;
  color: inherit;
  text-align: left;
  width: 100%;
}

.nav__accessibility-trigger:focus {
  outline: 2px solid #387db6;
  outline-offset: 2px;
}
</style>
